/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as DocumentService from "../../../../secure/services/documentService";
import * as fileUploadActions from "../../../../store/actions/fileUploadActions";
import AzureFileuploadHelper from "../../../../../utils/azureFileuploadHelper";

import {
  ViedocCheckboxElement,
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
} from "../../../../secure/elements/ViedocReactElements";
import _ from "underscore";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import { useDispatch, useSelector } from "react-redux";
import CalendarComponent from "../../shared/CalendarComponent/CalendarComponent";
import ProgressBar from "../../shared/widgets/ProgressBar";
import APP_CONST from "../../../shared/constants";
import { useMemo } from "react";
import moment from "moment";

const DocumentEditForm = ({
  docDetailsList,
  docStatusPayload,
  showRequiredWarnings,
  setShowRequiredWarnings,
  setIsEditFormTouched,
  setShowToaster,
  singleFileUploaded,
  setSingleFileUploaded,
  setNewArtifactId,
  selectedArtifactDetails,
  newVersionType,
  isNewVersionCreated,
  tmpGuid,
  setTmpGuid,
  isDropZoneDoc,
  setDocPermission,
  setArtifactUserAccess,
  resetFormToInitial,
  setResetFormToInitial,
  isEditMode,
  isFileUpload,
  setIsFileUpload,
  isDocReadOnly,
  setSingleFileDetail,
  setTmpFileGuid,
  setTmpSingleFileDetail,
  setIsDocNewVersionCreated,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    zoneid,
    zone,
    sectionid,
    section,
    origiartifactid,
    artifact,
    countriesid,
    sitesid,
    documenttmflevel,
    documenttype,
    datingconventiondate,
    title,
    archivetemplate,
    documenttypevalue,
    trialmasterfilesharingsettings,
    status,
  } = docDetailsList;

  const { fullDateTimePattern, dateLocale, settings } = useSelector(
    (store) => store.template
  );
  const documentExtension = UtilsHelper.getFileExtension(
    docDetailsList.filename || docDetailsList.documentname
  );
  const { zoneItems, countrySiteList, studyUserInfo } = useSelector(
    (store) => store.zone
  );
  const { tmfLevel, adminSharingSettings, zoneData } = useSelector(
    (store) => store.document
  );
  const { singleFile, isScanning, saveChanges, singleFileErrorMessage } =
    useSelector((store) => store.file);
  const [newDocData, setnewDocData] = useState();
  const [customTitle, setCustomTitle] = useState(
    docDetailsList?.customTitle ? docDetailsList?.customTitle : ""
  );
  const [customType, setCustomType] = useState(
    documenttype === APP_CONST.OTHER ? documenttypevalue : ""
  );

  const [chosenArtifact, setChosenArtifact] = useState();

  // Removing duplicate entries from the array [adminSharingSettings]
  const artifactSharingDetails =
    !_.isEmpty(adminSharingSettings) &&
    adminSharingSettings
      .filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          adminSharingSettings.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      })
      .find((el) => el.origiartifactid === origiartifactid);

  const noneCheckValue =
    isDropZoneDoc || _.isEmpty(trialmasterfilesharingsettings)
      ? true
      : artifactSharingDetails?.isenabledforclinicalusers ||
        artifactSharingDetails?.isenabledforsubjectusers
      ? trialmasterfilesharingsettings?.isnoneenabled
      : true;

  const clinicalUserCheckValue = _.isEmpty(trialmasterfilesharingsettings)
    ? false
    : artifactSharingDetails?.isenabledforclinicalusers
    ? trialmasterfilesharingsettings?.isenabledforclinicalusers
    : false;

  const viedocMeUserCheckValue = _.isEmpty(trialmasterfilesharingsettings)
    ? false
    : artifactSharingDetails?.isenabledforsubjectusers
    ? trialmasterfilesharingsettings?.isenabledforsubjectusers
    : false;

  const [sharingNoneChecked, setSharingNoneChecked] = useState(noneCheckValue);
  const [clinicalUserChecked, setClinicalUserChecked] = useState(
    clinicalUserCheckValue
  );
  const [viedocMeUserChecked, setViedocMeUserChecked] = useState(
    viedocMeUserCheckValue
  );

  const [disableClinicalChecked, setDisableClinicalChecked] = useState(
    !artifactSharingDetails?.isenabledforclinicalusers ? true : false
  );

  const [disableSubjectChecked, setDisableSubjectChecked] = useState(
    !artifactSharingDetails?.isenabledforsubjectusers ? true : false
  );

  const [versionDate, setVersionDate] = useState(datingconventiondate);

  const fileRef = useRef();

  const { country, site } = countrySiteList;

  const autoSelectSiteValue = [site.filter((st) => st.id)[0]?.text] || [];
  const autoSelectCountryValue = [country.filter((ct) => ct.id)[0]?.text] || [];

  const countryList = country.filter(function (item) {
    return docDetailsList?.countriesid?.indexOf(item.id) !== -1;
  });
  const siteList = site.filter(function (item) {
    return docDetailsList?.sitesid?.indexOf(item.id) !== -1;
  });

  const countryName = countriesid
    ?.map((objId) => {
      const findObject = _.find(countryList, { id: objId });
      return (
        <div className="cardBox" key={objId}>
          {!_.isEmpty(findObject) ? findObject.description : objId}
        </div>
      );
    })
    .map((name) => name.props.children);

  const siteName = sitesid
    ?.map((objId) => {
      const findObject = _.find(siteList, { id: objId });
      return (
        <div className="cardBox" key={objId}>
          {!_.isEmpty(findObject) ? findObject.description : objId}
        </div>
      );
    })
    .map((name) => name.props.children);

  const countryListDropdown = [
    ...country.map((ctry) => ({
      label: ctry.text,
      value: ctry.text,
      code: ctry.id,
    })),
  ];

  const siteListDropdown = [
    ...site.map((st) => ({
      label: st.text,
      value: st.text,
      code: st.id,
    })),
  ];

  const [selectedCountry, setSelectedCountry] = useState(countryName);
  const [selectedSite, setSelectedSite] = useState(siteName);
  const [selectedZone, setSelectedZone] = useState(
    isDropZoneDoc ? APP_CONST.SELECT_ZONE : zoneid + " " + zone
  );
  const [selectedZoneId, setSelectedZoneId] = useState(zoneid);
  const [selectedSection, setSelectedSection] = useState(
    isDropZoneDoc ? APP_CONST.SELECT_SECTION : sectionid + " " + section
  );
  const [selectedSectionId, setSelectedSectionId] = useState(sectionid);
  const [versionLabel, setVersionLabel] = useState(docDetailsList.version);
  const [docTitle, setDocTitle] = useState(docDetailsList.title);

  const [azureStorageData, setAzureStorageData] = useState();

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };
  const [selectedArtifact, setSelectedArtifact] = useState(
    isDropZoneDoc ? APP_CONST.SELECT_ARTIFACT : origiartifactid + " " + artifact
  );
  const selectedArtifactId = selectedArtifact.split(" ")[0];
  const docTmfLevel = documenttmflevel ? documenttmflevel : "";
  const [selectedScope, setSelectedScope] = useState(
    docTmfLevel || APP_CONST.SELECT_SCOPE
  );
  const [singleFileName, setSingleFileName] = useState();
  const [selectedDatingLabel, setSelectedDatingLabel] = useState();
  const sectionsItems = _.flatten(_.pluck(zoneItems, "sections"));
  const artiFactItems = _.flatten(_.pluck(sectionsItems, "artifacts"));

  const [artifactName, setArtifactName] = useState(
    title === "artifactName" ? true : false
  );
  const [originalName, setOriginalName] = useState(
    isDropZoneDoc ? true : title === "fileName" ? true : false
  );
  const [customName, setCustomName] = useState(
    title === "customName" ? true : false
  );
  const [selectedArtifactName, setSelectedArtifactName] = useState(artifact);

  const getDocumentType = () => {
    if (isDropZoneDoc) return APP_CONST.SELECT_DOCUMENT_TYPE;
    if (!documenttype && !documenttypevalue)
      return APP_CONST.SELECT_DOCUMENT_TYPE;
    return documenttype === "Sub-artifact"
      ? documenttypevalue === ""
        ? APP_CONST.SELECT_DOCUMENT_TYPE
        : documenttypevalue
      : documenttype === ""
      ? APP_CONST.SELECT_DOCUMENT_TYPE
      : documenttype;
  };

  const [selectedDocumentType, setSelectedDocumentType] = useState(
    getDocumentType()
  );

  const [temp, setTemplate] = useState({
    zoneName: "",
    zoneNumber: "",
    sectionName: "",
    sectionNumber: "",
    artifactName: "",
    artifactNumber: "",
    subArtifactName: "",
    TMFLevel: "",
    customName: "",
    siteName: "",
    siteCode: "",
    countryCode: "",
    countryName: "",
    version: "",
    systemVersion: 1,
    DatingConventionValue: "",
    datingconventionlabel: "",
    status: "",
    studyname: "",
    documentName: "",
    documentIdentifier: "",
    documentsystemversion: "",
    fileSystemVersion: "",
    documentType: "",
    dispTemplate: "disp?",
    downTemplate: "down?",
    archTemplate: "archive?",
  });

  const getDocumentTypeValue = () => {
    return selectedDocumentType === APP_CONST.OTHER
      ? customType || selectedArtifactName
      : ![APP_CONST.SELECT_DOCUMENT_TYPE, APP_CONST.MAIN_ARTIFACT].includes(
          selectedDocumentType
        )
      ? selectedDocumentType
      : selectedArtifactName;
  };

  const getTemplates = (templateType, updateTemp) => {
    let templateValue = templateType
      .replaceAll("{ZoneName}", updateTemp.zoneName)
      .replaceAll("{ZoneNumber}", updateTemp.zoneNumber)
      .replaceAll("{SectionName}", updateTemp.sectionName)
      .replaceAll("{SectionNumber}", updateTemp.sectionNumber)
      .replaceAll("{ArtifactName}", updateTemp.artifactName)
      .replaceAll("{ArtifactNumber}", updateTemp.artifactNumber)
      .replaceAll("{SubArtifactName}", updateTemp.subArtifactName)
      .replaceAll("{TMFLevel}", updateTemp.TMFLevel)
      .replaceAll("{SiteName}", updateTemp.siteName)
      .replaceAll("{SiteCode}", updateTemp.siteCode)
      .replaceAll("{CountryCode}", updateTemp.countryCode)
      .replaceAll("{CountryName}", updateTemp.countryName)
      .replaceAll("{VersionLabel}", updateTemp.version)
      .replaceAll("{DatingConventionValue}", updateTemp.DatingConventionValue)
      .replaceAll("{DocumentName}", updateTemp.documentName)
      .replaceAll("{DocumentId}", updateTemp.documentIdentifier)
      .replaceAll("{DatingConventionLabel}", updateTemp.datingconventionlabel)
      .replaceAll("{DocumentStatus}", updateTemp.status)
      .replaceAll("{StudyName}", updateTemp.studyname)
      .replaceAll("{DocumentVersion}", updateTemp.documentsystemversion)
      .replaceAll("{FileVersion}", updateTemp.fileSystemVersion);

    if (_.isEmpty(templateValue)) {
      if (originalName) {
        templateValue = !_.isEmpty(docDetailsList.origfilename)
          ? docDetailsList.origfilename
          : docDetailsList.filename;
      } else if (customName) {
        templateValue = customTitle;
      } else {
        templateValue = getDocumentTypeValue();
      }
    }
    return templateValue;
  };

  function updateTemplateNames() {
    let siteids = [];
    let countryids = [];
    let siteNames = selectedSite;
    let countryNames = selectedCountry;

    if (!_.isEmpty(selectedCountry)) {
      countryids = country
        .filter((ctry) => selectedCountry?.includes(ctry.description))
        .map((ctry1) => ctry1.id);
    }

    if (!_.isEmpty(selectedSite)) {
      siteids = site
        .filter((st) => selectedSite?.includes(st.description))
        .map((st1) => st1.siteCode);
      countryids = site
        .filter((st) => selectedSite?.includes(st.description))
        .map((st1) => st1.countryCode);

      countryNames = country
        .filter((ctry) => countryids.includes(ctry.id))
        .map((ctry) => ctry.description);
    }

    let uniquesiteId = Array.from(new Set(siteids));
    let uniquecountryId = Array.from(new Set(countryids));
    let uniquesitenames = Array.from(new Set(siteNames));
    let uniquecountrynames = Array.from(new Set(countryNames));

    let sIds =
      uniquesiteId && uniquesiteId.length > 1
        ? "Multiple sites"
        : uniquesiteId.map((ids) => ids).join(", ");
    let cIds =
      uniquecountryId && uniquecountryId.length > 1
        ? "Multiple countries"
        : uniquecountryId.map((ids) => ids).join(", ");
    let snames =
      uniquesitenames && uniquesitenames.length > 1
        ? "Multiple sites"
        : uniquesitenames.map((ids) => ids).join(", ");
    let cnames =
      uniquecountrynames && uniquecountrynames.length > 1
        ? "Multiple countries"
        : uniquecountrynames.map((ids) => ids).join(", ");

    const initValue = {
      zoneName:
        docDetailsList.zone && typeof docDetailsList.zone === "object"
          ? docDetailsList.zone.name
          : docDetailsList.zone || "",
      zoneNumber: docDetailsList.zoneid || "",
      sectionName:
        docDetailsList.section && typeof docDetailsList.section === "object"
          ? docDetailsList.section.name
          : docDetailsList.section || "",
      sectionNumber: docDetailsList.sectionid || "",
      artifactName:
        docDetailsList.artifact && typeof docDetailsList.artifact === "object"
          ? docDetailsList.artifact.name
          : docDetailsList.artifact || "",
      artifactNumber: docDetailsList.origiartifactid || "",
      subArtifactName:
        docDetailsList.documenttype !== APP_CONST.MAIN_ARTIFACT &&
        docDetailsList.documenttypevalue
          ? docDetailsList.documenttypevalue
          : "",
      TMFLevel: docDetailsList.documenttmflevel || "",
      customName: docDetailsList.origfilename || "",
      siteName: snames || "",
      siteCode: sIds || "",
      countryCode: cIds || "",
      countryName: cnames || "",
      version: docDetailsList.version || "",
      systemVersion: docDetailsList.version || 1,
      DatingConventionValue: docDetailsList.datingconventiondate || "",
      datingconventionlabel: docDetailsList.datingconventionlabel || "",
      status: docDetailsList.status || "",
      studyname: studyUserInfo.studyName || "",
      documentName: docDetailsList.tmfdropzoneid
        ? docDetailsList.filename
        : docDetailsList.documentName || docDetailsList.origfilename || "",
      documentIdentifier: docDetailsList.docid || null,
      documentsystemversion: docDetailsList.tmfdropzoneid
        ? "1"
        : docDetailsList.documentsystemversion || "",
      fileSystemVersion: docDetailsList.filesystemversion,
      documentType: docDetailsList.documenttype || "",
    };
    temp.zoneName = selectedZone.replace(/^\d+(\.\d+)?\s*/, "");
    if (selectedZone.replace(/^\d+(\.\d+)?\s*/, "") !== initValue.zoneName) {
      temp.sectionName = " ";
      temp.artifactName = " ";
      temp.subArtifactName = " ";
      temp.siteName = " ";
      temp.siteCode = " ";
      temp.countryName = " ";
      temp.countryCode = " ";
      temp.DatingConventionValue = " ";
      temp.TMFLevel = " ";
    }

    temp.zoneNumber = selectedZoneId;
    if (selectedZoneId !== initValue.zoneNumber) {
      temp.sectionNumber = " ";
      temp.artifactNumber = " ";
    }

    temp.sectionName = selectedSection !== APP_CONST.SELECT_SECTION ? selectedSection.replace(/^\d+(\.\d+)?\s*/, "") : " ";
    if (
      selectedSection.replace(/^\d+(\.\d+)?\s*/, "") !== initValue.sectionName
    ) {
      temp.artifactName = " ";
      temp.subArtifactName = " ";
      temp.siteName = " ";
      temp.siteCode = " ";
      temp.countryName = " ";
      temp.countryCode = " ";
      temp.DatingConventionValue = " ";
      temp.TMFLevel = " ";
    }

    temp.sectionNumber = selectedSection !== APP_CONST.SELECT_SECTION ?  selectedSectionId : " ";
    if (selectedSectionId !== initValue.sectionNumber) {
      temp.artifactNumber = " ";
    }

    temp.artifactName = selectedArtifact !== APP_CONST.SELECT_ARTIFACT ? selectedArtifactName : " ";
    if (selectedArtifactName !== initValue.artifactName) {
      temp.siteName = initValue.siteName;
      temp.siteCode = initValue.siteCode;
      temp.countryName = initValue.countryName;
      temp.countryCode = initValue.countryCode;
      temp.TMFLevel = selectedScope;
    }

    temp.artifactNumber = selectedArtifact !== APP_CONST.SELECT_ARTIFACT ?  selectedArtifactId : " ";
    temp.TMFLevel = selectedScope !== APP_CONST.SELECT_SCOPE ? selectedScope : " ";

    if (selectedDocumentType !== APP_CONST.MAIN_ARTIFACT && selectedArtifact !== APP_CONST.SELECT_ARTIFACT) {
      if (selectedDocumentType === APP_CONST.OTHER) {
        temp.subArtifactName = !_.isEmpty(customType)
          ? customType
          : " "
      } else {
        temp.subArtifactName =
          selectedDocumentType !== APP_CONST.SELECT_DOCUMENT_TYPE
            ? selectedDocumentType
            : " ";
      }
    } else {
      temp.subArtifactName = " "
    }

    temp.version = !_.isEmpty(versionLabel)
      ? versionLabel
      : " "

    temp.DatingConventionValue = !_.isEmpty(versionDate)
      ? versionDate
      : " "
    temp.fileSystemVersion = docDetailsList.filesystemversion
      ? docDetailsList.filesystemversion
      : " "

    temp.documentName = artifactName
      ? getDocumentTypeValue()
      : customName
      ? customTitle
      : docDetailsList.tmffilename || docDetailsList.filename;

    temp.documentIdentifier = docDetailsList.tmfdropzoneid ? " ": initValue.documentIdentifier;   

    let updateTemp = {
      zoneName: temp.zoneName || initValue.zoneName,
      zoneNumber: temp.zoneNumber || initValue.zoneNumber,
      sectionName: temp.sectionName || initValue.sectionName,
      sectionNumber: temp.sectionNumber || initValue.sectionNumber,
      artifactName: temp.artifactName || initValue.artifactName,
      artifactNumber: temp.artifactNumber || initValue.artifactNumber,
      subArtifactName: temp.subArtifactName || initValue.subArtifactName,
      customName: temp.customName || initValue.customName,
      TMFLevel: temp.TMFLevel || initValue.TMFLevel,
      siteName: temp.siteName || initValue.siteName,
      siteCode: temp.siteCode || initValue.siteCode,
      countryCode: temp.countryCode || initValue.countryCode,
      countryName: temp.countryName || initValue.countryName,
      version: temp.version || initValue.version,
      systemVersion:
        temp.documentsystemversion || initValue.documentsystemversion,
      DatingConventionValue:
        temp.DatingConventionValue && temp.DatingConventionValue !== " "
          ? moment(temp.DatingConventionValue).format("YYYYMMDD")
          : temp.DatingConventionValue === " "
          ? " "
          : initValue.DatingConventionValue
          ? moment(initValue.DatingConventionValue).format("YYYYMMDD")
          : "",
      datingconventionlabel:
        temp.datingconventionlabel || initValue.datingconventionlabel,
      documentType: temp.documentType || initValue.documentType,
      status: temp.status || initValue.status,
      studyname: temp.studyname || initValue.studyname,
      documentIdentifier:
        temp.documentIdentifier || initValue.documentIdentifier,
      documentName: temp.documentName || initValue.documentName,
      documentsystemversion:
        temp.documentsystemversion || initValue.documentsystemversion,
      fileSystemVersion: temp.fileSystemVersion || initValue.fileSystemVersion,
    };

    updateTemp.datingconventionlabel =
      selectedDatingLabel ? selectedDatingLabel : docDetailsList.datingconventionlabel ;

    let formDispTemp = getTemplates(settings.displaytemplate, updateTemp);
    let formDownTemp = getTemplates(settings.downloadtemplate, updateTemp);
    let formArcTemp = getTemplates(settings.archivetemplate, updateTemp);

    return { formDispTemp, formDownTemp, formArcTemp };
  }
  const { formDispTemp, formDownTemp, formArcTemp } = updateTemplateNames();

  const showInfo = isDropZoneDoc
    ? selectedArtifact !== APP_CONST.SELECT_ARTIFACT
      ? true
      : false
    : true;

  let zoneDropdown = [
    ...zoneItems
      .map((zoneItem) => ({
        value: zoneItem.origid + " " + zoneItem.name,
        label: zoneItem.origid + " " + zoneItem.name,
        isdeleted: zoneItem.isdeleted,
      }))
      .filter((zone) => !zone.isdeleted),
  ];
  zoneDropdown = [
    ...zoneDropdown,
    { value: APP_CONST.SELECT_ZONE, label: t("TMF.PLACEHOLDER_SELECTZONE") },
  ];

  let sectionDropdown = [
    ...sectionsItems
      .map((sectionItem) => ({
        value: sectionItem.origid + " " + sectionItem.name,
        label: sectionItem.origid + " " + sectionItem.name,
        zoneid: sectionItem.origid.split(".")[0],
        isdeleted: sectionItem.isdeleted,
      }))
      .filter(
        (section) => section.zoneid === selectedZoneId && !section.isdeleted
      ),
  ];
  sectionDropdown = [
    ...sectionDropdown,
    {
      value: APP_CONST.SELECT_SECTION,
      label: t("TMF.PLACEHOLDER_SELECTSECTION"),
    },
  ];

  const getSectionId = (origid) => {
    const activeOrigid = origid ? origid.split(".") : "";
    return activeOrigid ? `${activeOrigid[0]}.${activeOrigid[1]}` : "";
  };

  let artifactDropdown = [
    ...artiFactItems
      .map((artiFactItem) => ({
        value: artiFactItem.origid + " " + artiFactItem.name,
        label: artiFactItem.origid + " " + artiFactItem.name,
        sectionid: getSectionId(artiFactItem.origid),
        zoneid: artiFactItem.origid.split(".")[0],
        artifactid: artiFactItem.origid,
        isdeleted: artiFactItem.isdeleted,
        rolePermission: artiFactItem.rolePermission,
        subartifacts: artiFactItem.subartifacts,
        applicableatsite: artiFactItem.applicableatsite,
        applicableincountry: artiFactItem.applicableincountry,
        applicableintrial: artiFactItem.applicableintrial,
        artifactuseraccess: artiFactItem.artifactuseraccess,
        fileformats: artiFactItem.fileformats,
        investigatordocument: artiFactItem.investigatordocument,
        sponsordocument: artiFactItem.sponsordocument,
      }))
      .filter(
        (artifact) =>
          artifact.sectionid === selectedSectionId &&
          !artifact.isdeleted &&
          artifact.rolePermission !== "READ"
      ),
  ];

  artifactDropdown.map((art) =>
    art.fileformats.includes(documentExtension) || art.fileformats[0] === "*"
      ? (art.disabled = false)
      : (art.disabled = true)
  );

  artifactDropdown = [
    ...artifactDropdown,
    {
      value: APP_CONST.SELECT_ARTIFACT,
      label: t("TMF.PLACEHOLDER_SELECTARTIFACT"),
    },
  ];

  const [isInvestigator, setIsInvestigator] = useState(
    artiFactItems.filter((art) => art.origid === selectedArtifactId)[0]
      ?.investigatordocument
  );

  const [isSponsor, setIsSponsor] = useState(
    artiFactItems.filter((art) => art.origid === selectedArtifactId)[0]
      ?.sponsordocument
  );

  const tmfLevelOrder = tmfLevel.map((obj) => ({
    ...obj,
    displayOrder:
      obj.description && obj.description.toLowerCase() === "trial"
        ? 1
        : obj.description && obj.description.toLowerCase() === "site"
        ? 3
        : 2,
  }));
  const tmfLevelSorted = _.sortBy(tmfLevelOrder, "displayOrder");
  let tmfLevelValues = [
    ...tmfLevelSorted.map((tmfLevelItem) => ({
      value: tmfLevelItem.description,
      label: tmfLevelItem.description,
      id: tmfLevelItem.id,
    })),
  ];
  tmfLevelValues = [
    ...tmfLevelValues,
    { value: APP_CONST.SELECT_SCOPE, label: APP_CONST.SELECT_SCOPE },
  ];

  let allUserScope = artifactDropdown
    .filter((art) => art.artifactid === selectedArtifactId)[0]
    ?.artifactuseraccess.map((obj) => {
      let returnObj = obj;
      if (obj.userScope === "Study") returnObj = { ...obj, userScope: "Trial" };
      return returnObj;
    });

  allUserScope = _.groupBy(allUserScope, "userScope");

  const tmfListFromScope = Object.keys(allUserScope);

  const userScopeReturn = (dataList, from) => {
    let disableList = [];
    let selectOptions = {
      Country: [...countrySiteList.country],
      Site: [...countrySiteList.site],
      Trial: [],
    };
    let count = 0;
    const allow = [];
    dataList !== undefined &&
      dataList.map((obj) => {
        if (obj.access.includes("WRITE") || obj.access.includes("SIGN"))
          allow.push(obj.scopeCode);
        else count++;
      });
    if (dataList?.length !== count) {
      selectOptions[from] = _.filter(selectOptions[from], (obj) => {
        return allow.includes(obj.id);
      });
    } else disableList.push(from);
    return !tmfListFromScope.includes(from) || disableList.includes(from);
  };

  const getTmfLevelDropdown = () =>
    tmfLevelValues.map((scope) => {
      if (
        scope.value === "Trial" &&
        (artifactDropdown.filter(
          (art) => art.artifactid === selectedArtifactId
        )[0]?.applicableintrial === "Not permitted" ||
          userScopeReturn(allUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }
      if (
        scope.value === "Site" &&
        (artifactDropdown.filter(
          (art) => art.artifactid === selectedArtifactId
        )[0]?.applicableatsite === "Not permitted" ||
          userScopeReturn(allUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }
      if (
        scope.value === "Country" &&
        (artifactDropdown.filter(
          (art) => art.artifactid === selectedArtifactId
        )[0]?.applicableincountry === "Not permitted" ||
          userScopeReturn(allUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }

      return scope;
    });

  let tmfLevelDropdown = useMemo(
    () => getTmfLevelDropdown(),
    [selectedArtifactId]
  );

  const autoSelectScope = () => {
    const scopeLengthOne =
      tmfLevelDropdown.filter((tmf) => !tmf.disabled && tmf.id).length === 1;
    const scopeValue = tmfLevelDropdown.filter(
      (tmf) => !tmf.disabled && tmf.id
    )[0]?.value;
    if (
      !_.isEmpty(tmfLevelDropdown) &&
      scopeLengthOne &&
      settings.istmflevelenabled
    ) {
      setSelectedScope(scopeValue);
    }
    return scopeValue;
  };

  const autoSelectSubScope = (scopeValue) => {
    if (scopeValue === "Site" && settings.istmflevelenabled) {
      if (site.length === 1) {
        setSelectedSite(autoSelectSiteValue);
      }
    } else if (scopeValue === "Country" && settings.istmflevelenabled) {
      if (country.length === 1) {
        setSelectedCountry(autoSelectCountryValue);
      }
    }
  };

  useEffect(() => {
    const scopeValue = autoSelectScope();
    autoSelectSubScope(scopeValue);
  }, [tmfLevelDropdown]);

  useEffect(() => {
    if (resetFormToInitial) {
      formValidation();
      setResetFormToInitial(false);
    } else if (
      !isEditMode &&
      (status === "Flagged by QC" || status === "Awaiting review")
    ) {
      resetToInitialFormValue("Edit");
    }
    if (
      !resetFormToInitial &&
      isEditMode &&
      (status === "Flagged by QC" || status === "Awaiting review")
    ) {
      resetToInitialFormValue("Edit");
    }
  }, [resetFormToInitial, isEditMode]);

  useEffect(() => {
    const zoneDataArr = zoneData?.find(
      (zone) => zone?.origid === docDetailsList?.zoneid
    );
    const sectionDataArr = zoneDataArr?.sections?.find(
      (section) => section?.origid === docDetailsList?.sectionid
    );
    const artifactDataArr = sectionDataArr?.artifacts?.find(
      (artifact) => artifact?.origid === docDetailsList?.origiartifactid
    );
    if (zoneDataArr?.isdeleted) {
      setSelectedZone(APP_CONST.SELECT_ZONE);
      setSelectedSection(APP_CONST.SELECT_SECTION);
      setSelectedArtifact(APP_CONST.SELECT_ARTIFACT);
    } else if (sectionDataArr?.isdeleted) {
      setSelectedSection(APP_CONST.SELECT_SECTION);
      setSelectedArtifact(APP_CONST.SELECT_ARTIFACT);
    } else if (artifactDataArr?.isdeleted) {
      setSelectedArtifact(APP_CONST.SELECT_ARTIFACT);
    }
  }, [zoneData]);

  const subArtifact = artiFactItems.find(
    (arti) => arti.origid === selectedArtifactId
  )?.subartifacts;
  const subArtifactArray = !_.isEmpty(subArtifact)
    ? [APP_CONST.MAIN_ARTIFACT, ...subArtifact, APP_CONST.OTHER]
    : [APP_CONST.MAIN_ARTIFACT, APP_CONST.OTHER];

  let subArtifactDropdown = [
    ...subArtifactArray.map((subArtifact) => ({
      value: subArtifact,
      label: subArtifact,
    })),
  ];
  subArtifactDropdown = [
    ...subArtifactDropdown,
    {
      value: APP_CONST.SELECT_DOCUMENT_TYPE,
      label: APP_CONST.SELECT_DOCUMENT_TYPE,
    },
  ];

  const checkBoxArrayList = [
    {
      checkedValue: artifactName,
      name: "artifactName",
      label:
        selectedDocumentType === APP_CONST.OTHER
          ? t("TMF.TEXT_USEOTHERNAMELBL")
          : selectedDocumentType === APP_CONST.SELECT_DOCUMENT_TYPE ||
            selectedDocumentType === APP_CONST.MAIN_ARTIFACT
          ? t("TMF.TEXT_USEARTIFACTNAMELBL")
          : t("TMF.TEXT_USESUBARTIFACTNAMELBL"),
    },
    {
      checkedValue: originalName,
      name: "fileName",
      label: t("TMF.TEXT_USEORIGINALFILENAMELBL"),
    },
    {
      checkedValue: customName,
      name: "customName",
      label: t("TMF.TEXT_CUSTOMNAMELBL"),
    },
  ];

  const tmfDropdownArrayList = [
    {
      className: "classification-trail",
      name: "zone",
      dropList: zoneDropdown,
      selected: selectedZone,
      label: APP_CONST.TEXT_ZONE,
      isMultiple: false,
      isRequired: true,
      placeholder: t("TMF.PLACEHOLDER_SELECTZONE"),
    },
    {
      className: "classification-committee",
      name: "section",
      dropList: sectionDropdown,
      selected: selectedSection,
      label: APP_CONST.TEXT_SECTION,
      isMultiple: false,
      isRequired: true,
      placeholder: t("TMF.PLACEHOLDER_SELECTSECTION"),
    },
    {
      className: "classification-process",
      name: "artifact",
      dropList: artifactDropdown,
      selected: selectedArtifact,
      label: APP_CONST.TEXT_ARTIFACT,
      isMultiple: false,
      isRequired: true,
      placeholder: t("TMF.PLACEHOLDER_SELECTARTIFACT"),
    },
  ];


  const recordReadInfo = [
    {
      id: 1,
      label: t("TMF.TEXT_IDENTIFIER"),
      value: docDetailsList.docid,
    },
    {
      id: 2,
      label: t("TMF.TEXT_DISPLAYTEMPLATE"),
      value: formDispTemp
    },
    {
      id: 3,
      label: t("TMF.TEXT_DOWNLOADTEMPLATE"),
      value: formDownTemp
    },
    {
      id: 4,
      label: t("TMF.TEXT_ARCHIVETEMPLATE"),
      value: formArcTemp
    },
  ];

  const formInitialValue = {
    selectedZoneValue: isDropZoneDoc
      ? APP_CONST.SELECT_ZONE
      : zoneid + " " + zone,
    selectedSectionValue: isDropZoneDoc
      ? APP_CONST.SELECT_SECTION
      : sectionid + " " + section,
    selectedArtifactValue: isDropZoneDoc
      ? APP_CONST.SELECT_ARTIFACT
      : origiartifactid + " " + artifact,
    selectedScopeValue: docTmfLevel || APP_CONST.SELECT_SCOPE,
    selectedCountry: selectedScope === "Site" ? [] : countryName,
    selectedSiteValue: siteName,
    selectedDocumentValue: getDocumentType(),
    selectedCustomTypeValue: documenttype === APP_CONST.OTHER ? documenttypevalue : "",
    selectedArtifactName: title === "artifactName" ? true : false,
    selectedOriginalName: isDropZoneDoc
      ? true
      : title === "fileName"
      ? true
      : false,
    selectedCustomName: title === "customName" ? true : false,
    selectedDocumentCustomName: title === "customName" ? archivetemplate : "",
    selectedVersionLabel: docDetailsList.version,
    selectedVersionDate: datingconventiondate,
    selectedSharingNoneValue: noneCheckValue,
    selectedSharingClinicalValue: clinicalUserCheckValue,
    selectedSharingSubjectValue: viedocMeUserCheckValue,
  };

  useEffect(() => {
    prepareDocStatusPayload();

    if (!showRequiredWarnings) return;

    const { requiredFields } = docStatusPayload;

    const isSharingEmpty =
      !requiredFields.sharingNoneChecked &&
      !requiredFields.clinicalUserChecked &&
      !requiredFields.viedocMeUserChecked &&
      !isDocReadOnly;

    const isCustomTitleEmpty = customName ? _.isEmpty(customTitle) : false;

    const areRequiredFieldsFilled =
      requiredFields.selectedDocumentType !== APP_CONST.SELECT_DOCUMENT_TYPE &&
      requiredFields.selectedScope !== APP_CONST.SELECT_SCOPE &&
      requiredFields.selectedZone !== APP_CONST.SELECT_ZONE &&
      requiredFields.selectedSection !== APP_CONST.SELECT_SECTION &&
      requiredFields.selectedArtifact !== APP_CONST.SELECT_ARTIFACT &&
      !_.isEmpty(requiredFields.versionDate);

    const shouldShowWarningsForScope =
      (requiredFields.selectedScope === "Country" &&
        _.isEmpty(requiredFields.selectedCountry)) ||
      (requiredFields.selectedScope === "Site" &&
        _.isEmpty(requiredFields.selectedSite));

    const shouldShowWarningsForDocumentType =
      requiredFields.selectedDocumentType === APP_CONST.OTHER &&
      _.isEmpty(requiredFields.customType);

    if (areRequiredFieldsFilled && !isCustomTitleEmpty && !isSharingEmpty) {
      if (shouldShowWarningsForScope || shouldShowWarningsForDocumentType) {
        setShowRequiredWarnings(true);
      } else {
        setShowRequiredWarnings(false);
        setShowToaster(false);
      }
    } else if (requiredFields.customName) {
      if (_.isEmpty(requiredFields.customTitle && !areRequiredFieldsFilled)) {
        setShowRequiredWarnings(true);
      } else {
        setShowRequiredWarnings(false);
        setShowToaster(false);
      }
    } else {
      setShowRequiredWarnings(true);
    }
  });

  const prepareDocStatusPayload = () => {
    const oldDocumentData = generateDocumentData(docDetailsList);
    let updatedDocumentData = diffDocumentData(oldDocumentData, docDetailsList);

    docStatusPayload.documenttmfside = {
      isinvestigator: isInvestigator === "X",
      issponsor: isSponsor === "X",
    };
    docStatusPayload.trialmasterfilesharingsettings = {
      isenabledforclinicalusers: clinicalUserChecked,
      isenabledforsubjectusers: viedocMeUserChecked,
      isnoneenabled: sharingNoneChecked,
    };
    docStatusPayload.currentArtiId = docDetailsList.origiartifactid;
    docStatusPayload.documentId = isDropZoneDoc
      ? docDetailsList.fileguid || docDetailsList.dropzonefileguid
      : docDetailsList.documentid;
    docStatusPayload.category = isDropZoneDoc ? docDetailsList.category : null;
    docStatusPayload.docDetailsList = docDetailsList;
    docStatusPayload.origiartifactid = selectedArtifact?.split(" ")[0];
    docStatusPayload.azurestorageresponse = azureStorageData || "";
    docStatusPayload.oldOrigiArtifactid = selectedArtifact?.split(" ")[0];
    docStatusPayload.documentversionguid = isDropZoneDoc
      ? "00000000-0000-0000-0000-000000000001"
      : docDetailsList.documentversionguid;
    const docData = {
      documentDetails:
        singleFileUploaded && !_.isEmpty(newDocData?.documentDetails)
          ? { ...updatedDocumentData, ...newDocData.documentDetails }
          : updatedDocumentData,
    };
    docStatusPayload.documentContents = JSON.stringify(docData);

    docStatusPayload.workflowState = isDropZoneDoc
      ? "unpublished"
      : docDetailsList.status;
    docStatusPayload.workflowAction = "unpublish";
    docStatusPayload.requiredFields = {
      selectedScope,
      selectedDocumentType,
      selectedCountry,
      selectedSite,
      selectedZone,
      selectedSection,
      selectedArtifact,
      customType,
      customTitle,
      versionDate,
      docTitle,
      sharingNoneChecked,
      clinicalUserChecked,
      viedocMeUserChecked,
      customName,
    };
  };

  function getDocumentTypePayloadvalue() {
    if (
      selectedDocumentType === APP_CONST.SELECT_DOCUMENT_TYPE ||
      selectedDocumentType === ""
    )
      return "";
    if ([APP_CONST.MAIN_ARTIFACT, APP_CONST.OTHER].includes(selectedDocumentType))
      return selectedDocumentType;
    else return "Sub-artifact";
  }

  const generateDocumentData = (docDetailsList) => {
    const dataOfDocument = { ...docDetailsList };
    const documentData = {};
    let countriesid, sitesid;
    if (dataOfDocument.zone || dataOfDocument.tmfdropzoneid) {
      documentData.zoneid = selectedZone?.split(" ")[0];
      documentData.zone = selectedZone?.slice(3);
    } else {
      documentData.zoneid = "00";
      documentData.zone = "";
    }

    if (dataOfDocument.section || dataOfDocument.tmfdropzoneid) {
      documentData.sectionid = selectedSection?.split(" ")[0];
      documentData.section = selectedSection?.slice(6);
    } else {
      documentData.sectionid = `${documentData.zoneid}.00`;
      documentData.section = "";
    }

    if (dataOfDocument.artifact || dataOfDocument.tmfdropzoneid) {
      documentData.origiartifactid = selectedArtifact?.split(" ")[0];
      documentData.artifact = selectedArtifact?.slice(9);
    } else {
      documentData.origiartifactid = `${documentData.sectionid}.00`;
      documentData.artifact = "";
    }

    documentData.documentTmfLevelId =
      tmfLevel.find((tmf) => tmf.description === selectedScope)?.id ||
      APP_CONST.HARD_CODED.dummyId;
    documentData.documenttmflevel =
      selectedScope === APP_CONST.SELECT_SCOPE ? "" : selectedScope;
    if (selectedScope === "Country") {
      countriesid = country.filter((ctry) =>
        selectedCountry?.includes(ctry.description)
      );
      documentData.countriesid = countriesid?.map((ctry) => ctry.id);
    } else if (selectedScope === "Site") {
      sitesid = site.filter((st) => selectedSite?.includes(st.description));
      documentData.sitesid = sitesid?.map((st) => st.id);
      const countryCode = site.filter((st) =>
        selectedSite?.includes(st.description)
      )[0]?.countryCode;

      documentData.countriesid = [
        country.filter((ctry) => ctry?.countrycode === countryCode)[0]
          ?.countrycode,
      ];
    }
    if (isDropZoneDoc) {
      documentData.countriesid = countriesid?.map((ctry) => ctry.id) || [];
      documentData.sitesid = sitesid?.map((st) => st.id) || [];
    }

    documentData.documenttype = getDocumentTypePayloadvalue();
    documentData.documenttypevalue =
      selectedDocumentType === APP_CONST.OTHER
        ? customType
        : selectedDocumentType === APP_CONST.MAIN_ARTIFACT
        ? selectedArtifact?.slice(9)
        : selectedDocumentType === APP_CONST.SELECT_DOCUMENT_TYPE
        ? ""
        : selectedDocumentType;
    documentData.title = docTitle || "fileName";
    documentData.customTitle = docTitle === "customName" ? customTitle : null;
    documentData.version = versionLabel;

    documentData.datingconventiondate =
      dataOfDocument.datingconventiondate || versionDate ? versionDate : null;
    documentData.datingconventionlabel = selectedDatingLabel
      ? selectedDatingLabel
      : dataOfDocument.datingconventionlabel;

    documentData.artifactid = parseInt(selectedArtifact?.split(".")[2]);
    documentData.location = dataOfDocument.tmfdropzoneid
      ? "SE - Uppsala University Hospital"
      : undefined;
    return documentData;
  };

  const setZoneSetup = (selectedOption) => {
    const zoneId = selectedOption.split(" ")[0];
    const sectionId = zoneId + ".01";

    setSelectedZone(selectedOption);
    setSelectedZoneId(zoneId);
    setSelectedSection(APP_CONST.SELECT_SECTION);
    setSelectedSectionId(sectionId);
    setSelectedArtifact(APP_CONST.SELECT_ARTIFACT);
  };

  const setSectionSetup = (selectedOption) => {
    const sectionId = selectedOption.split(" ")[0];
    setSelectedSectionId(sectionId);
    setSelectedSection(selectedOption);

    setSelectedArtifact(APP_CONST.SELECT_ARTIFACT);
  };

  function filterValuefromArtifactDetails(artifactId, key) {
    return artiFactItems.filter((art) => art.origid === artifactId)[0][key];
  }

  const resetEnableValue = (artifactId, from) => {
    switch (from) {
      case "zone":
      case "section":
        setClinicalUserChecked(false);
        setViedocMeUserChecked(false);
        setSharingNoneChecked(true);
        setDisableClinicalChecked(true);
        setDisableSubjectChecked(true);
        break;
      case "artifact":
        const adminSharingValue = adminSharingSettings?.find(
          (obj) => obj.origiartifactid === artifactId
        );
        setDisableClinicalChecked(
          !adminSharingValue?.isenabledforclinicalusers
        );
        setDisableSubjectChecked(!adminSharingValue?.isenabledforsubjectusers);
        setClinicalUserChecked(false);
        setViedocMeUserChecked(false);
        adminSharingValue?.isenabledforclinicalusers ||
        adminSharingValue?.isenabledforsubjectusers
          ? setSharingNoneChecked(false)
          : setSharingNoneChecked(true);
        break;
      default:
        break;
    }
  };

  const resetScopeValue = () => {
    setSelectedScope(APP_CONST.SELECT_SCOPE);
    setSelectedCountry("");
    setSelectedSite("");
  };

  const setScopeValue = (artifactId) => {
    let tmfLevelOptionValues = [
      ...tmfLevelSorted.map((tmfLevelItem) => ({
        value: tmfLevelItem.description,
        label: tmfLevelItem.description,
        id: tmfLevelItem.id,
      })),
    ];
    tmfLevelOptionValues = [
      ...tmfLevelOptionValues,
      { value: APP_CONST.SELECT_SCOPE, label: APP_CONST.SELECT_SCOPE },
    ];

    let artifactAllUserScope = artifactDropdown
      .filter((art) => art.artifactid === artifactId)[0]
      ?.artifactuseraccess.map((obj) => {
        let returnObj = obj;
        if (obj.userScope === "Study")
          returnObj = { ...obj, userScope: "Trial" };
        return returnObj;
      });

    artifactAllUserScope = _.groupBy(artifactAllUserScope, "userScope");
    const tmfListFromScopeValue = Object.keys(artifactAllUserScope);
    const userScopeCheck = (dataList, from) => {
      let disableList = [];
      let selectOptions = {
        Country: [...countrySiteList.country],
        Site: [...countrySiteList.site],
        Trial: [],
      };
      let count = 0;
      const allow = [];
      dataList !== undefined &&
        dataList.map((obj) => {
          if (obj.access.includes("WRITE") || obj.access.includes("SIGN"))
            allow.push(obj.scopeCode);
          else count++;
        });
      if (dataList?.length !== count) {
        selectOptions[from] = _.filter(selectOptions[from], (obj) => {
          return allow.includes(obj.id);
        });
      } else disableList.push(from);
      return (
        !tmfListFromScopeValue.includes(from) || disableList.includes(from)
      );
    };
    const tmfLevelArr = tmfLevelOptionValues.map((scope) => {
      if (
        scope.value === "Trial" &&
        (artifactDropdown.filter((art) => art.artifactid === artifactId)[0]
          ?.applicableintrial === "Not permitted" ||
          userScopeCheck(artifactAllUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }
      if (
        scope.value === "Site" &&
        (artifactDropdown.filter((art) => art.artifactid === artifactId)[0]
          ?.applicableatsite === "Not permitted" ||
          userScopeCheck(artifactAllUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }
      if (
        scope.value === "Country" &&
        (artifactDropdown.filter((art) => art.artifactid === artifactId)[0]
          ?.applicableincountry === "Not permitted" ||
          userScopeCheck(artifactAllUserScope[scope.label], scope.label))
      ) {
        scope.disabled = true;
      }

      return scope;
    });

    if (docTmfLevel === "Site") {
      let siteEnableCheck = tmfLevelArr?.find(
        (siteValue) =>
          siteValue?.label === "Site" &&
          siteValue?.id &&
          !siteValue?.hasOwnProperty("disabled")
      );
      if (!_.isEmpty(siteEnableCheck)) {
        let isSiteExist = !_.isEmpty(siteName) ? siteName : "";
        setSelectedScope(siteEnableCheck?.value);
        setSelectedSite(isSiteExist);
        setSelectedCountry("");
      } else {
        resetScopeValue();
      }
    } else if (docTmfLevel === "Country") {
      let siteEnableCheck = tmfLevelArr?.find(
        (siteValue) =>
          siteValue?.label === "Country" &&
          siteValue?.id &&
          !siteValue?.hasOwnProperty("disabled")
      );
      if (!_.isEmpty(siteEnableCheck)) {
        let isCountryExist = !_.isEmpty(countryName) ? countryName : "";
        setSelectedScope(siteEnableCheck?.value);
        setSelectedCountry(isCountryExist);
        setSelectedSite("");
      } else {
        resetScopeValue();
      }
    } else if (docTmfLevel === "Trial") {
      let siteEnableCheck = tmfLevelArr?.find(
        (siteValue) =>
          siteValue?.label === "Trial" &&
          siteValue?.id &&
          !siteValue?.hasOwnProperty("disabled")
      );
      if (!_.isEmpty(siteEnableCheck)) {
        setSelectedScope(siteEnableCheck?.value);
        setSelectedSite("");
        setSelectedCountry("");
      } else {
        resetScopeValue();
      }
    } else {
      resetScopeValue();
    }
  };

  const setDropdownHandler = (event, location) => {
    const { value } = event.target;
    switch (location) {
      case APP_CONST.TEXT_ZONE:
        setZoneSetup(value);
        resetEnableValue("", "zone");
        break;
      case APP_CONST.TEXT_SECTION:
        setSectionSetup(value);
        resetEnableValue("", "section");
        break;
      case APP_CONST.TEXT_ARTIFACT:
        setSelectedArtifactName(value.slice(9));
        setSelectedArtifact(value);
        const artifactId = value.split(" ")[0];
        resetEnableValue(artifactId, "artifact");
        setNewArtifactId(artifactId);
        setDocPermission(
          filterValuefromArtifactDetails(artifactId, "rolePermission")
        );
        setArtifactUserAccess(
          filterValuefromArtifactDetails(artifactId, "artifactuseraccess")
        );
        setSelectedDatingLabel(
          filterValuefromArtifactDetails(artifactId, "datingconvention")
        );
        setIsInvestigator(
          filterValuefromArtifactDetails(artifactId, "investigatordocument")
        );

        setIsSponsor(
          filterValuefromArtifactDetails(artifactId, "sponsordocument")
        );
        setScopeValue(artifactId);
        const selectedArtifactDetails = artiFactItems.filter(
          (art) => art.origid === artifactId
        )[0];
        setChosenArtifact(selectedArtifactDetails);
        if (
          (docDetailsList?.documenttype === "Sub-artifact" &&
            !selectedArtifactDetails?.subartifacts?.includes(
              docDetailsList.documenttypevalue
            )) ||
          docDetailsList?.documenttype === APP_CONST.OTHER
        ) {
          setSelectedDocumentType(APP_CONST.SELECT_DOCUMENT_TYPE);
        }

        const scopeValue = autoSelectScope();
        autoSelectSubScope(scopeValue);
        break;
      case "Document type":
        setSelectedDocumentType(value);
        setCustomType("");
        break;
      case "TMF level":
        setSelectedCountry([]);
        setSelectedSite([]);
        setSelectedScope(value);
        autoSelectSubScope(value);
        break;
      case "ScopeCountry":
        setSelectedSite([]);
        setSelectedCountry(value);
        break;
      case "ScopeSite":
        setSelectedCountry([]);
        setSelectedSite(value);
        break;
      default:
        setSelectedSite("");
        setSelectedCountry("");
        break;
    }
  };

  const formValidation = () => {
    const removeEmptyValue = (Value) => Value?.filter((item) => item);
    const selectedFormValue = {
      selectedZoneValue: selectedZone,
      selectedSectionValue: selectedSection,
      selectedArtifactValue: selectedArtifact,
      selectedScopeValue: selectedScope,
      selectedCountry:
        selectedScope === "Site"
          ? []
          : !_.isEmpty(selectedCountry)
          ? removeEmptyValue(selectedCountry)
          : [],
      selectedSiteValue: !_.isEmpty(selectedSite)
        ? removeEmptyValue(selectedSite)
        : [],
      selectedDocumentValue: selectedDocumentType,
      selectedCustomTypeValue: customType,
      selectedArtifactName: artifactName,
      selectedOriginalName: originalName,
      selectedCustomName: customName,
      selectedDocumentCustomName: customTitle,
      selectedVersionLabel: versionLabel,
      selectedVersionDate: versionDate,
      selectedSharingNoneValue: sharingNoneChecked,
      selectedSharingClinicalValue: clinicalUserChecked,
      selectedSharingSubjectValue: viedocMeUserChecked,
    };

    if (selectedArtifact !== APP_CONST.SELECT_ARTIFACT) {
      if (
        isScanning ||
        (!isFileUpload &&
          JSON.stringify(formInitialValue) ===
            JSON.stringify(selectedFormValue))
      ) {
        setIsEditFormTouched(false);
      } else {
        !isDocReadOnly && setIsEditFormTouched(true);
      }
    } else {
      setIsEditFormTouched(false);
    }
  };

  useEffect(() => {
    formValidation();
  }, [
    selectedZone,
    selectedSection,
    selectedArtifact,
    selectedScope,
    selectedCountry,
    selectedSite,
    selectedDocumentType,
    customType,
    artifactName,
    originalName,
    customName,
    customTitle,
    versionLabel,
    versionDate,
    sharingNoneChecked,
    clinicalUserChecked,
    viedocMeUserChecked,
    isScanning,
  ]);

  useEffect(() => {
    if (isNewVersionCreated) {
      setSelectedZone(zoneid + " " + zone);
      setSelectedSection(sectionid + " " + section);
      setSelectedArtifact(origiartifactid + " " + artifact);
      setSelectedArtifactName(artifact);
    }
  }, [docDetailsList]);

  const checkIfValueValid = (value) => {
    if (
      value === APP_CONST.SELECT_DOCUMENT_TYPE ||
      value === APP_CONST.SELECT_SCOPE ||
      value === APP_CONST.SELECT_ZONE ||
      value === APP_CONST.SELECT_SECTION ||
      value === APP_CONST.SELECT_ARTIFACT ||
      _.isEmpty(value)
    ) {
      return true;
    }
    return false;
  };

  const renderDropdown = (
    name,
    mappingvalues,
    selectedValue,
    location,
    isMultiple,
    isRequired,
    placeholder
  ) => {
    return (
      <ViedocSelectElement
        size="small"
        multiple={isMultiple}
        value={selectedValue}
        placeholder={placeholder}
        className={
          isRequired && showRequiredWarnings && checkIfValueValid(selectedValue)
            ? "required-warning"
            : ""
        }
        disabled={
          (selectedZone === APP_CONST.SELECT_ZONE && name === "section") ||
          (selectedSection === APP_CONST.SELECT_SECTION && name === "artifact")
            ? true
            : false
        }
        onChange={(e) => setDropdownHandler(e, location)}
      >
        {mappingvalues.map((item, index) => (
          <ViedocMenuItemElement
            selected={checkIfPlaceholderRequired(item, "selected")}
            disabled={
              checkIfPlaceholderRequired(item, "other") || item.disabled
                ? true
                : false
            }
            hidden={checkIfPlaceholderRequired(item, "other")}
            key={index}
            value={item.value}
          >
            {UtilsHelper.getTranslatedScopeLabel(item.label)}
          </ViedocMenuItemElement>
        ))}
      </ViedocSelectElement>
    );
  };

  const checkIfPlaceholderRequired = (item, type) => {
    if (
      item.value === APP_CONST.SELECT_ZONE ||
      item.value === APP_CONST.SELECT_SECTION ||
      item.value === APP_CONST.SELECT_ARTIFACT ||
      item.value === APP_CONST.SELECT_SCOPE ||
      item.value === APP_CONST.SELECT_DOCUMENT_TYPE
    ) {
      return true;
    } else {
      if (type === "selected") {
        // checking if only one value of site or country is available and selecting it with true value
        if (isDropZoneDoc) {
          if (selectedArtifact !== APP_CONST.SELECT_ARTIFACT) {
            if (siteList.length === 1 || countryList.length === 1) {
              return true;
            } else return null; //null value will not allow autoselect if there will be more values in the multiselect
          } else {
            return null;
          }
        } else {
          if (siteList.length === 1 || countryList.length === 1) {
            return true;
          } else return null; //null value will not allow autoselect if there will be more values in the multiselect
        }
      } else return false;
    }
  };

  const renderScopeDropdown = () => {
    return renderDropdown(
      "scope",
      tmfLevelDropdown,
      selectedScope,
      "TMF level",
      false,
      true,
      "Select scope"
    );
  };

  const renderScopeTypeDropdown = () => {
    return selectedScope === "Country"
      ? renderDropdown(
          "country",
          countryListDropdown,
          selectedCountry,
          "ScopeCountry",
          true,
          true,
          "Select country"
        )
      : selectedScope === "Site"
      ? renderDropdown(
          "site",
          siteListDropdown,
          selectedSite,
          "ScopeSite",
          true,
          true,
          "Select site"
        )
      : null;
  };

  const renderDoctypeDropdown = () => {
    return renderDropdown(
      "doctype",
      subArtifactDropdown,
      selectedDocumentType,
      "Document type",
      false,
      true,
      "Select record type"
    );
  };

  const docScopeList = [
    {
      label: t("TMF.TEXT_SCOPE"),
      content: renderScopeDropdown(),
    },
    {
      label: "",
      content: renderScopeTypeDropdown(),
    },
    {
      label: t("TMF.TEXT_DOCTYPELBL"),
      content: renderDoctypeDropdown(),
    },
  ];

  const renderDocumentClassification = () => {
    return (
      <div className="document-classification pt-20">
        <div className="classification-header">
          <p className="">{t("ADMIN.TEXT_CLASSIFICATIONLBL")}</p>
          <div className="sub-header">
            <label className="mt-10">
              {t("TMF.TEXT_TMFLOCATIONLBL")}
              {spanFunc()}
            </label>
            <div className="classification-folder">
              {tmfDropdownArrayList.map((tmfList, index) => (
                <div key={index} className={tmfList.className}>
                  {renderDropdown(
                    tmfList.name,
                    tmfList.dropList,
                    tmfList.selected,
                    tmfList.label,
                    tmfList.isMultiple,
                    tmfList.isRequired,
                    tmfList.placeholder
                  )}
                </div>
              ))}
            </div>
          </div>
          {showInfo && (
            <>
              {docScopeList.map((doc, index) => (
                <div key={index} className="sub-header sub-center">
                  <label>
                    {doc.label}
                    {doc.label !== "" && spanFunc()}
                  </label>
                  <div className="sub-select">{doc.content}</div>
                </div>
              ))}

              {selectedDocumentType === APP_CONST.OTHER && (
                <div className="sub-header sub-center">
                  <label>
                    {t("TMF.TEXT_CUSTOMTYPELBL")}
                    {spanFunc()}
                  </label>
                  <div className="sub-select">
                    <viedoc-textfield
                      size="small"
                      class={
                        showRequiredWarnings &&
                        (customType === null || customType === "")
                          ? "w-82 required-warning"
                          : "w-82"
                      }
                    >
                      <input
                        type="text"
                        placeholder="Type..."
                        value={customType}
                        onChange={(e) => {
                          setCustomType(e.target.value);
                        }}
                      />
                    </viedoc-textfield>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  const nameTitleHandler = (event, fromCheckbox) => {
    switch (fromCheckbox) {
      case "artifactName":
        setArtifactName(true);
        setOriginalName(false);
        setCustomName(false);
        setCustomTitle("");
        break;
      case "fileName":
        setArtifactName(false);
        setOriginalName(true);
        setCustomName(false);
        setCustomTitle("");
        break;
      case "customName":
        setArtifactName(false);
        setOriginalName(false);
        setCustomName(true);
        break;
      default:
        break;
    }
    setDocTitle(fromCheckbox);
  };

  const getGuid = async () => {
    try {
      const guidResp = await DocumentService.doGetDocumentGuid();
      if (guidResp.status === 200) {
        return guidResp.data.result.documentguid;
      } else {
        return null;
      }
    } catch (e) {}
  };

  const diffDocumentData = (newData, oldData) => {
    const oldDocumentData = {};
    Object.keys(newData).map((key) => {
      oldDocumentData[key] = oldData[key];
    });
    let updateDocumentData = UtilsHelper.getObjectDiff(
      newData,
      oldDocumentData
    );
    updateDocumentData = {
      ...updateDocumentData,
      lastmodifiedon: oldData.lastmodifiedon,
    };
    return updateDocumentData;
  };

  const onUpload = async (event) => {
    const { files } = event.target;
    dispatch(fileUploadActions.singleFileErrorToaster(""));
    const selectedArtifactDetail = artiFactItems.find(
      (artifact) => artifact.origid === selectedArtifactId
    );
    const { fileformats } = selectedArtifactDetail;
    const fileType = UtilsHelper.getFileExtension(files[0].name);
    const allowAllFormats = fileformats.length === 1 && fileformats[0] === "*";
    if (
      APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(fileType) &&
      files[0].size !== 0
    ) {
      dispatch(
        fileUploadActions.singleFileErrorToaster(
          t("TMF.TOAST_INVALIDBLOCKLISTFILE")
        )
      );
      return;
    } else if (files[0].size === 0) {
      dispatch(
        fileUploadActions.singleFileErrorToaster(t("TMF.TOAST_FILEEMPTY"))
      );
      return;
    } else if (!allowAllFormats && !fileformats.includes(fileType)) {
      dispatch(
        fileUploadActions.singleFileErrorToaster(
          `${t("TMF.TOAST_INVALIDFILEFORMATS")} ${fileformats}.`
        )
      );
      return;
    }
    setSingleFileDetail(files);
    setIsDocNewVersionCreated(isNewVersionCreated);
    setTmpSingleFileDetail(files);
    setSingleFileName(files[0].name);
    const guid = await getGuid();
    setTmpGuid(guid);
    setTmpFileGuid(guid);
    dispatch(
      fileUploadActions.singleFileProgressing({
        id: guid,
        uploadingProgress: 10,
      })
    );
    const newDocDetails = {};
    newDocDetails.documentguid = guid;
    newDocDetails.documentname = files[0].name;
    newDocDetails.type = UtilsHelper.getFileExtension(files[0].name);
    newDocDetails.tmffilename = files[0].name;
    newDocDetails.origfilename = files[0].name;
    newDocDetails.fileSize = files[0].size;
    newDocDetails.lastmodifiedon = docDetailsList.lastmodifiedon
      ? docDetailsList.lastmodifiedon
      : null;
    newDocDetails.datingconventiondate = docDetailsList.datingconventiondate
      ? docDetailsList.datingconventiondate
      : null;

    setnewDocData({ documentDetails: newDocDetails });
    docStatusPayload.documentContents = JSON.stringify({
      documentDetails: newDocDetails,
    });
    const uploadProgressCb = (ev) => {
      const response = Math.round((ev.loadedBytes * 100) / files[0].size);
      // don't remove below console
      // console.log("uploadProgressCb", response);
    };
    let azureStorageResponse = {};
    try {
      const azureData = await AzureFileuploadHelper.uploadFiles(
        files[0],
        guid,
        uploadProgressCb
      );
      azureStorageResponse = JSON.stringify(azureData);
      setAzureStorageData(azureStorageResponse);
    } catch (e) {}
    let reqPayload = {
      id: guid,
      tmfDocumentId: docDetailsList.documentid,
      lastmodifiedon: docDetailsList.lastmodifiedon,
    };
    if (
      isNewVersionCreated ||
      ["Awaiting review", "Flagged by QC"].includes(docDetailsList?.status)
    ) {
      reqPayload.documentversionid = docDetailsList.documentversionguid;
    }
    dispatch(fileUploadActions.createNewDocVersion(reqPayload));
    setSingleFileUploaded(true);
    setIsFileUpload(true);
  };

  const postCancelHandler = () => {
    setIsEditFormTouched(false);
    setSingleFileUploaded(false);
    setSingleFileName();
    setTmpGuid(null);
    setTmpFileGuid(null);
  };

  const cancelUploadHandler = () => {
    dispatch(fileUploadActions.createNewDocVersionCancel(tmpGuid));
    postCancelHandler();
  };

  const getFieldValue = () => {
    if (isDropZoneDoc) {
      return docDetailsList.filename;
    }
    if (singleFileName) {
      return singleFileName;
    }
    if (newVersionType === APP_CONST.TEXT_UPLOAD_VERSION) {
      return t("TMF.TEXT_UPLOADNEWFILE");
    }
    return docDetailsList.origfilename;
  };

  const renderOriginalFilenameContent = () => {
    return (
      <>
        <viedoc-textfield
          size="small"
          variant="outline"
          class={singleFileErrorMessage ? "required-warning" : ""}
          title={getFieldValue()}
        >
          <input
            type="text"
            disabled
            className="disabled-input-field"
            value={getFieldValue()}
          />
        </viedoc-textfield>
        {!isScanning && !isDropZoneDoc && (
          <viedoc-icon
            name="flip_to_front"
            onClick={() => fileRef.current.click()}
            title={t("TMF.TEXT_UPLOAD")}
          />
        )}
        <input
          id="doc-upload"
          className="d-sm-none"
          ref={fileRef}
          type="file"
          onChange={(e) => onUpload(e)}
          onClick={(event) => {
            event.target.value = null;
          }}
        />
        {singleFile.uploadingProgress < 100 &&
          singleFile.uploadingProgress > 0 &&
          isScanning && (
            <div
              className="d-flex jc-center align-center ml-10 gap-8"
              style={{ fontSize: "14px" }}
            >
              <viedoc-spinner size="small" class="spinner"></viedoc-spinner>

              <ProgressBar progress={singleFile.uploadingProgress || 0} />
              {singleFile.uploadingProgress !== 99 && (
                <viedoc-icon
                  name="delete"
                  title={t("TMF.BUTTON_CANCELBTN")}
                  onClick={() => cancelUploadHandler()}
                ></viedoc-icon>
              )}
            </div>
          )}
      </>
    );
  };

  let IsNewFileUpload =
    (newVersionType === APP_CONST.TEXT_UPLOAD_VERSION && isNewVersionCreated) ||
    isScanning ||
    saveChanges;

  const fileInfoList = [
    {
      label: t("TMF.TEXT_ORIGFILENAMELBL"),
      content: renderOriginalFilenameContent(),
      fieldName: APP_CONST.TEXT_ORIGINAL_FILE_NAME
    },
    {
      label: t("TMF.TEXT_FILESIZE"),
      content: UtilsHelper.getFileSize(
        docDetailsList.fileSize ||
          docDetailsList.filesize ||
          docDetailsList.sizeinbytes
      ),
      fieldName: APP_CONST.TEXT_FILE_SIZE
    },
    {
      label: t("TMF.TEXT_FILEDATELBL"),
      content: fullDateTimePattern
        ? UtilsHelper.getFormattedDateTime(
            fullDateTimePattern,
            isDropZoneDoc ? docDetailsList.createdon : docDetailsList?.filedate,
            dateLocale
          )
        : UtilsHelper.momentLocalConversion(
            isDropZoneDoc ? docDetailsList.createdon : docDetailsList?.filedate,
            true
          ),
      fieldName: APP_CONST.TEXT_FILE_DATE
    },
    {
      label: t("TMF.TEXT_FILEVERSION"),
      content: isDropZoneDoc ? "---" : docDetailsList?.filesystemversion,
      fieldName: APP_CONST.TEXT_FILE_VERSION
    },
    {
      label: t("TMF.TEXT_INTEGRITYVALUE"),
      content: isDropZoneDoc ? "---" : docDetailsList?.fileintegrity,
      fieldName: APP_CONST.TEXT_FILE_INTEGRITY
    },
  ];

  const sharingInfoList = [
    {
      id: 1,
      label: t("TMF.TEXT_NONE"),
      checked: sharingNoneChecked,
      disabled: false,
      isRequired: true,
    },
    {
      id: 2,
      label: t("TMF.TEXT_VIEDOCCLINICALUSERS"),
      checked: clinicalUserChecked,
      disabled: disableClinicalChecked,
      isRequired: true,
    },
    {
      id: 3,
      label: t("TMF.LABEL_VIEDOCMEUSERS"),
      checked: viedocMeUserChecked,
      disabled: disableSubjectChecked,
      isRequired: true,
    },
  ];

  const resetToInitialFormValue = (from) => {
    let versionDateValue = from ? datingconventiondate : "";
    /*classification*/
    setSelectedZone(
      isDropZoneDoc ? APP_CONST.SELECT_ZONE : zoneid + " " + zone
    );
    setSelectedSection(
      isDropZoneDoc ? APP_CONST.SELECT_SECTION : sectionid + " " + section
    );
    setSelectedArtifact(
      isDropZoneDoc
        ? APP_CONST.SELECT_ARTIFACT
        : origiartifactid + " " + artifact
    );
    setSelectedScope(docTmfLevel || APP_CONST.SELECT_SCOPE);
    setSelectedCountry(countryName);
    setSelectedSite(siteName);
    setSelectedDocumentType(getDocumentType());
    setSelectedZoneId(zoneid);
    setSelectedSectionId(sectionid);
    /* record info */
    setArtifactName(title === "artifactName" ? true : false);
    setOriginalName(isDropZoneDoc ? true : title === "fileName" ? true : false);
    setCustomName(title === "customName" ? true : false);
    setCustomTitle(title === "customName" ? archivetemplate : "");
    setVersionLabel(docDetailsList.version);
    setVersionDate(versionDateValue);
    /*file info */
    singleFileName && postCancelHandler();
    /* sharing info */
    setSharingNoneChecked(
      isDropZoneDoc || _.isEmpty(trialmasterfilesharingsettings)
        ? true
        : artifactSharingDetails?.isenabledforclinicalusers ||
          artifactSharingDetails?.isenabledforsubjectusers
        ? trialmasterfilesharingsettings?.isnoneenabled
        : true
    );
    setClinicalUserChecked(
      isDropZoneDoc || _.isEmpty(trialmasterfilesharingsettings)
        ? false
        : trialmasterfilesharingsettings?.isenabledforclinicalusers
    );
    setViedocMeUserChecked(
      isDropZoneDoc || _.isEmpty(trialmasterfilesharingsettings)
        ? false
        : trialmasterfilesharingsettings?.isenabledforsubjectusers
    );
    setResetFormToInitial(false);
  };

  const renderFileInfo = () => {
    return (
      <div className="document-info pt-20">
        <div className="document-info-header">
          <p>{t("TMF.TEXT_FILEINFOLBL")}</p>
        </div>
        {fileInfoList.map((fileInfo, index) => (
          <div key={index} className="sub-header">
            <p>
              {fileInfo.label}
              {fileInfo.fieldName === APP_CONST.TEXT_ORIGINAL_FILE_NAME &&
              newVersionType === APP_CONST.TEXT_UPLOAD_VERSION
                ? spanFunc()
                : ""}
            </p>
            <div className="document-checkbox">
              {fileInfo.fieldName === APP_CONST.TEXT_ORIGINAL_FILE_NAME
                ? fileInfo.content
                : IsNewFileUpload
                ? "---"
                : fileInfo.content}
            </div>
          </div>
        ))}
      </div>
    );
  };

  function sharingChangeHandler(from) {
    switch (from) {
      case t("TMF.TEXT_NONE"):
        setSharingNoneChecked(true);
        setClinicalUserChecked(false);
        setViedocMeUserChecked(false);
        break;
      case t("TMF.TEXT_VIEDOCCLINICALUSERS"):
        setSharingNoneChecked(false);
        setClinicalUserChecked(true);
        setViedocMeUserChecked(false);
        break;
      case t("TMF.LABEL_VIEDOCMEUSERS"):
        setSharingNoneChecked(false);
        setClinicalUserChecked(false);
        setViedocMeUserChecked(true);
        break;
      default:
        break;
    }
  }

  const renderSharingInfo = () => {
    return (
      <div className="document-info pt-20">
        <div className="document-info-header">
          <p>{t("ADMIN.ADMINTAB_SHARING")}</p>
        </div>
        <div className="sub-header">
          <p>
            {t("TMF.TEXT_ENABLEFOR")}
            {spanFunc()}
          </p>
          {sharingInfoList.map((sharing) => (
            <div key={sharing.id} className="pl-30 tmfside-checkbox">
              <ViedocRadioElement
                name="sharing"
                size="small"
                checked={sharing.checked}
                disabled={sharing.disabled}
                required={
                  !sharing.disabled &&
                  sharing.isRequired &&
                  showRequiredWarnings &&
                  sharingInfoList.every((item) => !item.checked)
                }
                onChange={(e) => sharingChangeHandler(sharing.label)}
              >
                {sharing.label}
              </ViedocRadioElement>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const setDocumentInfoFieldHandler = (event, from) => {
    const { value } = event.target;
    switch (from) {
      case "CustomName":
        setCustomTitle(value.trimStart());
        break;
      case "VersionLabel":
        setVersionLabel(value.trimStart());
        break;
      default:
        break;
    }
  };

  // Render Document Info
  const renderDocumentInfo = () => {
    return (
      showInfo && (
        <>
          <div className="document-info">
            <div className="document-info-header">
              <p>{t("TMF.TEXT_DOCINFOLBL")}</p>
            </div>
            <div className="sub-header">
              <p>
                {t("DETAILPAGE.LABEL_DOCUMENTNAME")}
                {spanFunc()}
              </p>
              <div className="document-checkbox">
                {checkBoxArrayList.map((checkbox, index) => (
                  <ViedocCheckboxElement
                    key={index}
                    checked={checkbox.checkedValue}
                    onChange={(e) => nameTitleHandler(e, checkbox.name)}
                  >
                    {checkbox.label}
                  </ViedocCheckboxElement>
                ))}
              </div>
            </div>
            <div className="sub-header">
              <p></p>
              <div className="document-checkbox">
                <viedoc-textfield
                  size="small"
                  variant="outline"
                  class={
                    showRequiredWarnings && customName && _.isEmpty(customTitle)
                      ? "required-warning"
                      : ""
                  }
                >
                  <input
                    className={!customName ? "disabled-field" : ""}
                    type="text"
                    disabled={!customName}
                    value={
                      artifactName
                        ? getDocumentTypeValue()
                        : customName
                        ? customTitle
                        : docDetailsList.tmffilename || docDetailsList.filename
                    }
                    onChange={(e) =>
                      setDocumentInfoFieldHandler(e, "CustomName")
                    }
                    title={
                      artifactName
                        ? getDocumentTypeValue()
                        : customName
                        ? customTitle
                        : docDetailsList.tmffilename || docDetailsList.filename
                    }
                  />
                </viedoc-textfield>
              </div>
            </div>
            <div className="sub-header">
              <p>{t("TMF.TEXT_VERSIONLBL")}</p>
              <div className="document-checkbox">
                <viedoc-textfield size="small" variant="outline">
                  <input
                    type="text"
                    value={versionLabel}
                    disabled=""
                    onChange={(e) =>
                      setDocumentInfoFieldHandler(e, "VersionLabel")
                    }
                  />
                </viedoc-textfield>
              </div>
            </div>
            <div className="sub-header">
              <p>
                {selectedDatingLabel ||
                  selectedArtifactDetails?.datingconvention ||
                  docDetailsList?.datingconventionlabel}
                {spanFunc()}
              </p>
              <CalendarComponent
                versionDate={versionDate}
                setVersionDate={setVersionDate}
                className={
                  !versionDate && showRequiredWarnings ? "required-warning" : ""
                }
              />
            </div>
            {recordReadInfo.map((recInfo) => (
              <div className="sub-header" key={recInfo.id}>
                <p>{recInfo.label}</p>
                <div className="document-checkbox">
                  <viedoc-textfield size="small" variant="outline">
                    <input type="text" value={recInfo.value} disabled title={recInfo.value}/>
                  </viedoc-textfield>
                </div>
              </div>
            ))}
            <div className="sub-header">
              <p>{t("TMF.TEXT_TMFSIDE")}</p>
              <div className="document-checkbox">
                <ViedocCheckboxElement
                  checked={
                    isDropZoneDoc
                      ? chosenArtifact.sponsordocument === "X"
                      : docDetailsList?.admintmfside?.issponsor
                  }
                  disabled
                >
                  {t("TMF.FORMLABEL_SPONSOR")}
                </ViedocCheckboxElement>
                <ViedocCheckboxElement
                  checked={
                    isDropZoneDoc
                      ? chosenArtifact.investigatordocument === "X"
                      : docDetailsList?.admintmfside?.isinvestigator
                  }
                  disabled
                >
                  {t("TMF.FORMLABEL_INVESTIGATOR")}
                </ViedocCheckboxElement>
              </div>
            </div>
          </div>
          <div className="bb-1 mt-20"></div>
        </>
      )
    );
  };

  return (
    <div className="document-edit">
      {renderDocumentClassification()}

      <div className="bb-1 mt-20"></div>

      {renderDocumentInfo()}

      {renderFileInfo()}

      <div className="bb-1 mt-20"></div>
      {renderSharingInfo()}
      <div className="bb-1 mt-20"></div>
    </div>
  );
};

export default DocumentEditForm;
